export const FORCE_DESKTOP_QUERY_PARAM = 'forceDesktop';

export const isForceDesktopSearch = (search: string): boolean =>
    new URLSearchParams(search).get(FORCE_DESKTOP_QUERY_PARAM) === '1';

export const isForceDesktopRequestUrl = (requestUrl: string): boolean => {
    try {
        return new URL(requestUrl).searchParams.get(FORCE_DESKTOP_QUERY_PARAM) === '1';
    } catch {
        return false;
    }
};

export const openForceDesktopVersion = (): void => {
    const url = new URL(window.location.href);

    url.searchParams.set(FORCE_DESKTOP_QUERY_PARAM, '1');
    window.location.assign(url.toString());
};
